<div class="common-wrapper">
    <div class="main-hd-txt">
        <h4>
            <pageheader [entity]="headerDirector"></pageheader>
        </h4>
    </div>
    <div *ngIf="listView" class="top-btns">
        <grid [entities]="directors" [actionExclude]="['feedback','column']" [checkboxCol]="true"
            [entityColumns]="directorColumns" [selectionField]="'Director_Id'" [addEntityIcon]="'bi bi-plus-square'"
            [addEntityCaption]="'Add'" [downloadEntityCaption]="'Download'" (downloadEntities)="onExcelExport()"
            (addEntity)="addDirector($event)" (editEntity)="editDirector($event)"
            (refreshEntities)="refreshDirector($event)" (deleteEntity)="deleteDirector($event)"
            (onPaginationChange)="onPaginationChange($event)" [serverPagination]="true" [pageSizes]="pageSizes"
            [pageSize]="defaultPageSize" [skip]="pageSkip" (onFilterChange)="onFilterChange($event)"></grid>

    </div>

    <div *ngIf="!listView">
        <div class="row sub-head">
            <div class="col-md-7 text-bold">
                {{ formCaption }}
            </div>
            <div class="col-md-5 text-end">
                <button (click)="clearDirector()" class="btn-3 bt-3-ic"><span>Clear</span></button>
                <button (click)="revertChanges()" class="btn-3 bt-4-ic"><span>Revert Changes</span></button>
                <button (click)="gotoBack()" class="btn-3 bt-4-ic"><span>Go Back</span></button>
            </div>
        </div>
        <div class="tab-wrap">
            <!-- active tab on page load gets checked attribute -->
            <input type="radio" id="tab1" [(ngModel)]="aciveTab" value="1" name="tabGroup1" class="tab" checked />
            <label for="tab1">GENERAL</label>

            <input type="radio" id="tab2" [(ngModel)]="aciveTab" value="2" name="tabGroup1" class="tab" />
            <label for="tab2">Educational Qualifications</label>

            <input type="radio" id="tab3" [(ngModel)]="aciveTab" value="3" name="tabGroup1" class="tab" />
            <label for="tab3">Professional Experience</label>

            <input type="radio" id="tab4" [(ngModel)]="aciveTab" value="4" name="tabGroup1" class="tab" />
            <label for="tab4">Forms Filed and Intimations</label>

            <input type="radio" id="tab5" [(ngModel)]="aciveTab" value="5" name="tabGroup1" class="tab" />
            <label for="tab5">Other</label>
            <div class="tab__content">
                <div class="container-fluid" *ngIf="aciveTab==1">
                    <div class="col-md-12">
                        <div class="col-md-12 row ">
                            <div class="btn-outer-box">
                                <div class="btn-box-rt">
                                    <button (click)="goToNextTab()" type="button" title="Next Tab"
                                        class="next-btn-head">Next <i class="bi bi-arrow-right-circle"></i></button>
                                </div>
                                <div class="btn-box-rt">
                                    <button (click)="save($event,proofTypes)" [disabled]="saveDisabled" type="button"
                                        title="Save Current Tab" class="save-btn-head"><i
                                            class="bi bi-file-earmark-plus"></i> Save</button>
                                </div>
                                <div class="btn-box-rt">
                                    <button (click)="goToBackTab()" class="go-back-btn-head" title="Back Tab"><i
                                            class="bi bi-arrow-left-circle"></i> Back</button>
                                </div>
                            </div>

                        </div>
                        <div class="row">

                            <div class="col-md-4 mb-2">
                                <textbox [caption]="'Director Name'" [mandatory]="true" [maxlength]="100"
                                    [formData]="entity" [fieldName]="'DirectorName'" [(ngModel)]="entity.DirectorName"
                                    (keypress)="AlphabetsOnly($event)" ngDefaultControl></textbox>
                            </div>
                            <div class="col-md-4 mb-2">
                                <dropdown [caption]="'Designation'" [mandatory]="true" [formData]="entity"
                                    [data]="designations" [filterable]="true"
                                    (filterChanged)="getAllDesignations($event)" [(ngModel)]="entity.Designation_Id"
                                    [textField]="'DesignationName'" [valueField]="'Designation_Id'"
                                    [fieldName]="'Designation_Id'" [class]="'form-control'"
                                    [selectedItem]="selectedDesignation" ngDefaultControl>
                                </dropdown>

                            </div>
                        </div>
                        <!-- <p>Contact Details </p> -->
                        <div class="row">
                            <div class="col-md-4">
                                <textbox [caption]="'Email id'" [mandatory]="false" [maxlength]="100"
                                    [formData]="entity" [maxlength]="100" [fieldName]="'EmailId'"
                                    [(ngModel)]="entity.EmailId" ngDefaultControl>
                                </textbox>
                            </div>
                            <div class="col-md-4 mb-2">
                                <textbox [caption]="'Phone'" [mandatory]="false" [maxlength]="10" [formData]="entity"
                                    [fieldName]="'Phone'" (keypress)="numberOnly($event)" [(ngModel)]="entity.Phone"
                                    ngDefaultControl></textbox>
                            </div>
                        </div>


                        <div class="row" *ngFor="let type of proofTypes">
                            <!-- <ng-container *ngIf="type.Istextbox; then loggedIn; else loggedOut "> -->
                            <!-- </ng-container> -->
                            <ng-template [ngIf]="type.Istextbox" [ngIfElse]="loggedOut">
                                <!-- <div class="col-md-4 mb-2" *ngIf="(type.displayName!= 'DOB')||(type.displayName!= '')"> -->
                                <div class="col-md-4 mb-2 ">
                                    <textbox [caption]="type.displayName" [placeholder]="type.description"
                                        [mandatory]="true" [maxlength]="type.maxlength" [(ngModel)]="type.value"
                                        ngDefaultControl>
                                    </textbox>
                                    <!-- <span class="alert" *ngIf="Isvalidation">{{type.validationMessage}}</span> -->
                                </div>
                            </ng-template>
                            <ng-template #loggedOut>
                                <div class="col-md-4 mb-2 mt-4" *ngIf="(type.displayName== 'Membership')">
                                    <!-- <div class="col-md-4 mb-2"> -->
                                    <checkbox [caption]="type.displayName" [(ngModel)]="type.value"></checkbox>

                                    <!-- </div> -->
                                </div>

                                <div class="col-md-4 mb-2" *ngIf="(type.displayName!= 'Membership')">
                                    <!-- <div class="col-md-4 mb-2"> -->
                                    <datepicker [caption]="type.displayName" [placeholder]="type.description"
                                        [mandatory]="true" [(ngModel)]="type.value" [datePicker]="true"
                                        ngDefaultControl>
                                    </datepicker>
                                    <!-- <span class="alert" *ngIf="Isvalidation">{{type.validationMessage}}</span> -->
                                    <!-- </div> -->
                                </div>
                            </ng-template>
                            <div class="col-md-8 mb-2 mt-4">
                                <input id="file-input" type="file" (change)="dirfileChanged($event,type);"
                                    accept=".pdf,.doc" />
                                <a *ngIf="type.proofType==='DIN'" id="DINlink" download>{{DINdownload}}</a>
                                <a *ngIf="type.proofType==='PAN'" id="PANlink" download>{{PANdownload}}</a>
                                <a *ngIf="type.proofType==='Aadhaar'" id="Aadhaarlink" download>{{Aadhaardownload}}</a>
                                <a *ngIf="type.proofType==='DOB'" id="DOBlink" download>{{DOBdownload}}</a>
                                <a *ngIf="type.proofType==='DOA'" id="DOAlink" download>{{DOAdownload}}</a>
                                <a *ngIf="type.proofType==='ReAppointmentDate'" id="ReAppointmentDatelink"
                                    download>{{ReAppointmentDatedownload}}</a>
                                <a *ngIf="type.proofType==='Membership'" id="Membershiplink"
                                    download>{{Membershipdownload}}</a>
                                <input type="button" id="downloadbutton" *ngIf="this.isDownloadButtonVisible"
                                    (click)="downloadFunction(type)" value="Download" downloadLink />
                                <span>
                                    <!-- <img [src]="type.url" height="70" class="imgClass"> -->
                                    <input type="button" id="removeImage1" class="close" *ngIf="type.button"
                                        (click)="removedirImage($event,type);" value="x" />
                                </span>
                            </div>
                            <!-- <div class="col-md-3 ">
                    <span (click)="savedocuments($event,'address');"><i class="bi bi-upload"></i>Upload</span> 
                </div> -->
                        </div>
                        <!-- <div class="row">
            <div class="col-md-4 mb-2">
                <textbox [caption]="'DIN'" [mandatory]="true"  [formData]="entity"
                    [maxlength]="500" [fieldName]="'DIN'" [(ngModel)]="entity.DIN"
                    ngDefaultControl>
                </textbox>
            </div>
            <div class="col-md-4 mb-2">
            <input id="file-input1" type="file" (change)="file_Changed($event,'url_DIN');" /> 
                <span>
                    <img [src]="url_DIN" height="70" class="imgClass">
                    <input type="button" id="removeImage1" class="close" *ngIf="this.isButtonVisible_din"
                        (click)="remove_Image($event,'url_DIN');" value="x" />
                </span>
      </div>  </div> 
      <div class="row">
        <div class="col-md-4 mb-2">
            <textbox [caption]="'PAN'" [mandatory]="true"  [formData]="entity"
                [maxlength]="500" [fieldName]="'PAN'" [(ngModel)]="entity.PAN"
                ngDefaultControl>
            </textbox>
        </div>
        <div class="col-md-4 mb-2">
        <input id="file-input" type="file" (change)="fileChanged($event);" /> 
            <span>
                <img [src]="url" height="70" class="imgClass">
                <input type="button" id="removeImage1" class="close" *ngIf="this.isButtonVisible"
                    (click)="removeImage($event);" value="x" />
            </span>
  </div>  </div>
  <div class="row">
    <div class="col-md-4 mb-2">
        <textbox [caption]="'Aadhar'" [mandatory]="true"  [formData]="entity"
            [maxlength]="500" [fieldName]="'Aadhar'" [(ngModel)]="entity.Aadhar"
            ngDefaultControl>
        </textbox>
    </div>
    <div class="col-md-4 mb-2">
    <input id="file-input" type="file" (change)="fileChanged($event);" /> 
        <span>
            <img [src]="url" height="70" class="imgClass">
            <input type="button" id="removeImage1" class="close" *ngIf="this.isButtonVisible"
                (click)="removeImage($event);" value="x" />
        </span>
</div>  </div>
<div class="row">
    <div class="col-md-4 mb-2">
       
        <datepicker [caption]="'DOB'"[placeholder]="'DOB'" [fieldName]="'StartDate'"
        [formData]="entity" [mandatory]="true" [(ngModel)]="entity.DOB" [datePicker]="true"
        ngDefaultControl>
    </datepicker>
    </div>
    <div class="col-md-4 mb-2">
        <input id="file-input" type="file" (change)="fileChanged($event);" /> 
            <span>
                <img [src]="url" height="70" class="imgClass">
                <input type="button" id="removeImage1" class="close" *ngIf="this.isButtonVisible"
                    (click)="removeImage($event);" value="x" />
            </span>
    </div>
 </div>

<div class="row">
    <div class="col-md-4 mb-2">
      
        <datepicker [caption]="'Date of Appointment'"[placeholder]="'Date of Appointment'" [fieldName]="'StartDate'"
        [formData]="entity" [mandatory]="true" [(ngModel)]="entity.AppointmentDate" [datePicker]="true"
        ngDefaultControl>
    </datepicker>
    </div>
    <div class="col-md-4 mb-2">
        <input id="file-input" type="file" (change)="fileChangedother($event);" /> 
            <span>
                <img [src]="url_" height="70" class="imgClass">
                <input type="button" id="removeImage1" class="close" *ngIf="this.isButtonVisible"
                    (click)="removeImage($event);" value="x" />
            </span>
    </div> 
     </div>

<div class="row">
    <div class="col-md-4 mb-2">
        <textbox [caption]="'Forms Filed and Intimations'" [mandatory]="true"  [formData]="entity"
            [maxlength]="500" [fieldName]="'FormsFiled'" [(ngModel)]="entity.FormsFiled"
            ngDefaultControl>
        </textbox>
    </div>
    <div class="col-md-4 mb-2">
    <input id="file-input" type="file" (change)="fileChanged($event);" /> 
        <span>
            <img [src]="url" height="70" class="imgClass">
            <input type="button" id="removeImage1" class="close" *ngIf="this.isButtonVisible"
                (click)="removeImage($event);" value="x" />
        </span>
</div>  </div>
<div class="row">
    <div class="col-md-4">
        <checkbox [caption]="' Membership'" [(ngModel)]="entity.Membership"></checkbox>
    </div>
    <div class="col-md-4 mb-2">
        <input id="file-input" type="file" (change)="fileChanged($event);" /> 
            <span>
                <img [src]="url" height="70" class="imgClass">
                <input type="button" id="removeImage1" class="close" *ngIf="this.isButtonVisible"
                    (click)="removeImage($event);" value="x" />
            </span>
    </div> 
</div> -->
                        <!-- <p>Contact Details </p>
                    <div class="row">
                        <div class="col-md-4">
                            <textbox [caption]="'Email id'" [mandatory]="true" [maxlength]="100" [formData]="entity"
                                [maxlength]="25" [fieldName]="'EmailId'" [(ngModel)]="entity.EmailId" ngDefaultControl>
                            </textbox>
                        </div>
                        <div class="col-md-4 mb-2">
                            <textbox [caption]="'Phone'" [mandatory]="true" [maxlength]="10" [formData]="entity"
                                [fieldName]="'Phone'" (keypress)="numberOnly($event)" [(ngModel)]="entity.Phone"
                                ngDefaultControl></textbox>
                        </div>
                    </div> -->
                        <div class="row">
                            <div class="col-md-4">
                                <checkbox [caption]="' Active'" [(ngModel)]="entity.IsActive"></checkbox>
                            </div>

                        </div>
                        <!-- <div class="row">
                            <div class="col-md-1">
                                <btn [label]="'Back'" (click)="goToBackTab()" [class]="'btn-next btn-11'"
                                    [type]="'button'" title="Back Tab"></btn>
                            </div>
                            <div class="col-md-1">
                                <btn [label]="'Save'" (click)="save($event,proofTypes)" [class]="'btn-1 btn-11'"
                                    [disabled]="saveDisabled" [type]="'button'"></btn>
                            </div>
                            <div class="col-md-1">
                                <btn [label]="'Next'" (click)="goToNextTab()" [class]="'btn-next btn-11'"
                                    [type]="'button'" title="Next Tab"></btn>
                            </div>
                           
                        </div> -->
                    </div>
                </div>
            </div>
            <div class="tab__content">
                <div class="container-fluid tab-btn-align" *ngIf="aciveTab==2"> <br />
                    <div class="col-md-12 row ">
                        <div class="btn-outer-box">
                            <div class="btn-box-rt">
                                <button (click)="goToNextTab()" type="button" title="Next Tab"
                                    class="next-btn-head">Next <i class="bi bi-arrow-right-circle"></i></button>
                            </div>
                            <div class="btn-box-rt">
                                <button (click)="save_Qualifications($event,entities_EDU)" [disabled]="EduDisabled"
                                    type="button" title="Save Current Tab" class="save-btn-head"><i
                                        class="bi bi-file-earmark-plus"></i> Save</button>
                            </div>
                            <div class="btn-box-rt">
                                <button (click)="goToBackTab()" class="go-back-btn-head" title="Back Tab"><i
                                        class="bi bi-arrow-left-circle"></i> Back</button>
                            </div>
                        </div>

                    </div>
                    <p style="font: bold;">Educational Qualifications</p>
                    <button (click)="addnewrow_EDU()" title="Add" class="add-btn-head mb-2" type="button"><i
                            class="bi bi-plus-circle"></i> Add
                    </button>
                    <kendo-grid header="Educational Qualifications" [data]="entities_EDU" style="width: 100%;">
                        <kendo-grid-column class="row">


                            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                                <div class="col-md-4 mb-2">
                                    <textbox [caption]="'Qualification Name'" [mandatory]="false" [maxlength]="100"
                                        [formData]="entity" [fieldName]="'QualificationName'"
                                        [(ngModel)]="dataItem.QualificationName" (keypress)="AlphabetsOnly($event)"
                                        ngDefaultControl></textbox>
                                </div>
                                <div class="col-md-8 mt-file-btn">
                                    <input id="file-input" type="file" (change)="fileChanged($event,dataItem,rowIndex);"
                                        accept=".pdf,.doc" />
                                    <a [id]="'link' + rowIndex" download>Download</a>
                                    <input type="button" id="downloadbutton" *ngIf="this.isDownloadButtonVisible"
                                        (click)="edudownloadFunction(dataItem,rowIndex)" value="Download" downloadLink />
                                    <span>
                                        <!-- <img [src]="dataItem.url" height="70" class="imgClass"> -->
                                        <input type="button" id="removeImage1" class="close" *ngIf="dataItem.button"
                                            (click)="removeImage($event);" value="x" />
                                    </span>
                                </div>
                                <span><button (click)="deleteRow_EDU(rowIndex)" class="del-btn-head" type="button"><i
                                            class="bi bi-trash"></i> Delete</button></span>
                                <!--<btn [label]="'Delete'" (click)="deleteRow_EDU(rowIndex)" [class]="'btn-1 btn-11'"
                                    [type]="'button'"></btn>-->
                                <!-- <button kendoButton class="add-btn" icon="plus" look="flat"
                                (click)="addnewrow_EDU(rowIndex)"></button> -->
                                <!-- <button kendoButton class="add-btn" icon="delete" look="flat"
                                (click)="deleteRow_EDU(rowIndex)"></button> -->
                            </ng-template>

                        </kendo-grid-column>
                    </kendo-grid>
                    <!-- <div class="row">
                        <div class="col-md-1">
                            <btn [label]="'Back'" (click)="goToBackTab()" [class]="'btn-next btn-11'" [type]="'button'"
                                title="Back Tab"></btn>
                        </div>
                        <div class="col-md-1">
                            <btn [label]="'Add'" (click)="addnewrow_EDU()" [class]="'btn-1 btn-11'" [type]="'button'">
                            </btn>
                        </div>
                        <div class="col-md-1">
                            <btn [label]="'Save'" (click)="save_Qualifications($event,entities_EDU)"
                                [class]="'btn-1 btn-11'" [disabled]="EduDisabled" [type]="'button'"></btn>
                        </div>
                        <div class="col-md-1">
                            <btn [label]="'Next'" (click)="goToNextTab()" [class]="'btn-next btn-11'" [type]="'button'"
                                title="Next Tab"></btn>
                        </div>
                    </div> -->
                </div>
            </div>
            <div class="tab__content">
                <div class="container-fluid tab-btn-align" *ngIf="aciveTab==3">
                    <br />
                    <div class="col-md-12 row ">
                        <div class="btn-outer-box">
                            <div class="btn-box-rt">
                                <button (click)="goToNextTab()" type="button" title="Next Tab"
                                    class="next-btn-head">Next <i class="bi bi-arrow-right-circle"></i></button>
                            </div>
                            <div class="btn-box-rt">
                                <button (click)="save_Professional ($event,entities_PRO)" [disabled]="ProDisabled"
                                    type="button" title="Save Current Tab" class="save-btn-head"><i
                                        class="bi bi-file-earmark-plus"></i> Save</button>
                            </div>
                            <div class="btn-box-rt">
                                <button (click)="goToBackTab()" class="go-back-btn-head" title="Back Tab"><i
                                        class="bi bi-arrow-left-circle"></i> Back</button>
                            </div>
                        </div>

                    </div>
                    <p style="font: bold;">Professional Experience with Enclosures</p>

                    <button (click)="addnewrow_PRO()" title="Add" class="add-btn-head mb-2" type="button"><i
                            class="bi bi-plus-circle"></i> Add
                    </button>

                    <kendo-grid header="Professional Experience with Enclosures" [data]="entities_PRO"
                        style="width: 100%;">

                        <!-- <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
            <es-textbox [class]="'es-input-control'" [(ngModel)]="dataItem.IFC_Risk_Number"
              
                name="IFC Risk Number" ngDefaultControl>
            </es-textbox>
        </ng-template> -->



                        <kendo-grid-column class="row">
                            <ng-template #apporder let-dataItem let-rowIndex="rowIndex">
                                <textbox [(ngModel)]="dataItem.ProfessionalName" [maxlength]="2" ngDefaultControl>
                                </textbox>
                            </ng-template>

                            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                                <div class="col-md-4 mb-2">

                                    <textbox [caption]="' Professional Experience'" [mandatory]="false"
                                        [maxlength]="100" [formData]="entity" [fieldName]="'ProfessionalName'"
                                        [(ngModel)]="dataItem.ProfessionalName" (keypress)="AlphabetsOnly($event)"
                                        ngDefaultControl></textbox>
                                </div>
                                <div class="col-md-2 mb-2">
                                    <textbox [caption]="' Experience in Years'" [mandatory]="false" [maxlength]="100"
                                        [formData]="entity" [fieldName]="'Experience_Year'"
                                        [(ngModel)]="dataItem.Experience_Year" (keypress)="numberOnly($event)"
                                        ngDefaultControl></textbox>
                                </div>
                                <div class="col-md-6 mb-2 mt-file-btn">
                                    <input id="file-input" type="file" (change)="professionalfileChanged($event,dataItem,rowIndex);"
                                        accept=".pdf,.doc" />
                                    <a [id]="'link' + rowIndex" download>Download</a>
                                    <input type="button" id="downloadbutton" *ngIf="this.isDownloadButtonVisible"
                                    (click)="professionaldownloadFunction(dataItem,rowIndex)" value="Download" downloadLink />
                                    <span>
                                        <!-- <img [src]="url" height="70" class="imgClass"> -->
                                        <input type="button" id="removeImage1" class="close"
                                            *ngIf="this.isButtonVisible" (click)="removeImage($event);" value="x" />
                                    </span>
                                </div>
                                <span><button (click)="deleteRow_PRO(rowIndex)" class="del-btn-head" type="button"><i
                                            class="bi bi-trash"></i> Delete</button></span>

                                <!-- <btn [label]="'Delete'" (click)="deleteRow_PRO(rowIndex)" [class]="'btn-1 btn-11'"
                                    [type]="'button'"></btn> -->

                                <!-- <button kendoButton class="add-btn" icon="plus" look="flat"
                                (click)="addnewrow_PRO(rowIndex)"></button>
                            <button kendoButton class="add-btn" icon="delete" look="flat"
                                (click)="deleteRow_PRO(rowIndex)"></button> -->
                            </ng-template>

                        </kendo-grid-column>
                    </kendo-grid>
                    <!-- <div class="row">
                        <div class="col-md-1">
                            <btn [label]="'Back'" (click)="goToBackTab()" [class]="'btn-next btn-11'" [type]="'button'"
                                title="Back Tab"></btn>
                        </div>
                        <div class="col-md-1">
                            <btn [label]="'Add'" (click)="addnewrow_PRO()" [class]="'btn-1 btn-11'" [type]="'button'">
                            </btn>
                        </div>
                        <div class="col-md-1">
                            <btn [label]="'Save'" (click)="save_Professional ($event,entities_PRO)"
                                [class]="'btn-1 btn-11'" [disabled]="ProDisabled" [type]="'button'"></btn>
                        </div>
                        <div class="col-md-1">
                            <btn [label]="'Next'" (click)="goToNextTab()" [class]="'btn-next btn-11'" [type]="'button'"
                                title="Next Tab"></btn>
                        </div>
                    </div> -->
                </div>
            </div>
            <div class="tab__content">
                <div class="container-fluid tab-btn-align" *ngIf="aciveTab==4">
                    <br />
                    <div class="col-md-12 row ">
                        <div class="btn-outer-box">
                            <div class="btn-box-rt">
                                <button (click)="goToNextTab()" type="button" title="Next Tab"
                                    class="next-btn-head">Next <i class="bi bi-arrow-right-circle"></i></button>
                            </div>
                            <div class="btn-box-rt">
                                <button (click)="save_Forms ($event,entities_FORMS)" [disabled]="FormDisabled"
                                    type="button" title="Save Current Tab" class="save-btn-head"><i
                                        class="bi bi-file-earmark-plus"></i> Save</button>
                            </div>
                            <div class="btn-box-rt">
                                <button (click)="goToBackTab()" class="go-back-btn-head" title="Back Tab"><i
                                        class="bi bi-arrow-left-circle"></i> Back</button>
                            </div>
                        </div>

                    </div>
                    <p style="font: bold;">Forms Filed and Intimations </p>

                    <button (click)="addnewrow_FORMS()" title="Add" class="add-btn-head mb-2" type="button"><i
                            class="bi bi-plus-circle"></i> Add
                    </button>
                    <kendo-grid header="Forms Filed and Intimations " [data]="entities_FORMS" style="width: 100%;">

                        <!-- <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
        <es-textbox [class]="'es-input-control'" [(ngModel)]="dataItem.IFC_Risk_Number"
          
            name="IFC Risk Number" ngDefaultControl>
        </es-textbox>
    </ng-template> -->


                        <kendo-grid-column class="row">


                            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                                <div class="col-md-4 mb-2">
                                    <textbox [caption]="' Forms Filed Name'" [mandatory]="false" [maxlength]="100"
                                        [formData]="entity" [fieldName]="'FormsFiledEnclosures'"
                                        [(ngModel)]="dataItem.FormFiledName" (keypress)="AlphabetsOnly($event)"
                                        ngDefaultControl></textbox>
                                </div>
                                <div class="col-md-8 mt-file-btn">
                                    <input id="file-input" type="file" (change)="formsfileChanged($event,dataItem,rowIndex);"
                                        accept=".pdf,.doc" />
                                    <a [id]="'link' + rowIndex" download>Download</a>
                                    <input type="button" id="downloadbutton" *ngIf="this.isDownloadButtonVisible"
                                    (click)="formsdownloadFunction(dataItem,rowIndex)" value="Download" downloadLink />
                                    <span>
                                        <!-- <img [src]="url" height="70" class="imgClass"> -->
                                        <input type="button" id="removeImage1" class="close"
                                            *ngIf="this.isButtonVisible" (click)="removeImage($event);" value="x" />
                                    </span>
                                </div>

                                <!-- <button kendoButton class="add-btn" icon="plus" look="flat"
                                (click)="addnewrow_FORMS(rowIndex)"></button>
                            <button kendoButton class="add-btn" icon="delete" look="flat"
                                (click)="deleteRow_FORMS(rowIndex)"></button> -->
                                <span><button (click)="deleteRow_FORMS(rowIndex)" class="del-btn-head" type="button"><i
                                            class="bi bi-trash"></i> Delete</button></span>

                                <!-- <btn [label]="'Delete'" (click)="deleteRow_FORMS(rowIndex)" [class]="'btn-1 btn-11'"
                                    [type]="'button'"></btn> -->

                            </ng-template>

                        </kendo-grid-column>
                    </kendo-grid>

                    <!-- <div class="row">
                        <div class="col-md-1">
                            <btn [label]="'Back'" (click)="goToBackTab()" [class]="'btn-next btn-11'" [type]="'button'"
                                title="Back Tab"></btn>
                        </div>
                        <div class="col-md-1">
                            <btn [label]="'Add'" (click)="addnewrow_FORMS()" [class]="'btn-1 btn-11'" [type]="'button'">
                            </btn>
                        </div>
                        <div class="col-md-1">
                            <btn [label]="'Save'" (click)="save_Forms ($event,entities_FORMS)" [class]="'btn-1 btn-11'"
                                [disabled]="FormDisabled" [type]="'button'"></btn>
                        </div>
                        <div class="col-md-1">
                            <btn [label]="'Next'" (click)="goToNextTab()" [class]="'btn-next btn-11'" [type]="'button'"
                                title="Next Tab"></btn>
                        </div>
                    </div> -->

                </div>
            </div>
            <div class="tab__content">
                <div class="container-fluid tab-btn-align" *ngIf="aciveTab==5">
                    <br />
                    <div class="col-md-12 row ">
                        <div class="btn-outer-box">
                            <!-- <div class="btn-box-rt">
                                <button (click)="goToNextTab()" type="button" title="Next Tab"
                                    class="next-btn-head">Next <i class="bi bi-arrow-right-circle"></i></button>
                            </div> -->

                            <div class="btn-box-rt">
                                <button (click)="save_all($event)" [disabled]="SubmitDisabled" type="button"
                                    title="Save All" class="save-btn-head"><i class="bi bi-file-earmark-plus"></i>
                                    Submit</button>
                            </div>
                            <div class="btn-box-rt">
                                <button (click)="save_OtherEnclosure($event,entities_OTHER)" type="button"
                                    title="Save Current Tab" class="save-btn-head" [disabled]="OtherDisabled">
                                    <i class="bi bi-file-earmark-plus"></i> Save</button>
                            </div>
                            <div class="btn-box-rt">
                                <button (click)="goToBackTab()" class="go-back-btn-head" title="Back Tab"><i
                                        class="bi bi-arrow-left-circle"></i> Back</button>
                            </div>

                        </div>

                    </div>
                    <p style="font: bold;">Other Enclosures</p>

                    <button (click)="addnewrow_OTHER()" title="Add" class="add-btn-head mb-2" type="button"><i
                            class="bi bi-plus-circle"></i> Add
                    </button>
                    <kendo-grid header="Other Enclosures" [data]="entities_OTHER" style="width: 100%;">

                        <!-- <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
        <es-textbox [class]="'es-input-control'" [(ngModel)]="dataItem.IFC_Risk_Number"
          
            name="IFC Risk Number" ngDefaultControl>
        </es-textbox>
    </ng-template> -->


                        <kendo-grid-column class="row">


                            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                                <div class="col-md-4 mb-2">
                                    <textbox [caption]="' Other Enclosures Name'" [mandatory]="false" [maxlength]="100"
                                        [formData]="entity" [fieldName]="'OtherEnclosures'"
                                        [(ngModel)]="dataItem.Tittle" (keypress)="AlphabetsOnly($event)"
                                        ngDefaultControl></textbox>
                                </div>
                                <div class="col-md-8 mt-file-btn">
                                    <input id="file-input" type="file" [(ngModel)]="dataItem.imgOtherEnclosures"
                                        (change)="fileChangedother($event,rowIndex,dataItem);" accept=".pdf,.doc" />
                                    <a [id]="'link' + rowIndex" download>Download</a>
                                    <input type="button" id="downloadbutton" *ngIf="this.isDownloadButtonVisible"
                                    (click)="Otherdownload(dataItem,rowIndex)" value="Download" downloadLink />
                                    <span>
                                        <!-- <img [src]="url" height="70" class="imgClass"> -->
                                        <input type="button" id="removeImage1" class="close"
                                            *ngIf="this.isButtonVisible" (click)="removeImage($event);" value="x" />
                                    </span>
                                </div>
                                <span><button (click)="deleteRow_OTHER(rowIndex)" class="del-btn-head" type="button"><i
                                            class="bi bi-trash"></i> Delete</button></span>

                                <!-- <btn [label]="'Delete'" (click)="deleteRow_OTHER(rowIndex)" [class]="'btn-1 btn-11'"
                                    [type]="'button'"></btn> -->

                                <!-- <button kendoButton class="add-btn" icon="plus" look="flat"
                                (click)="addnewrow_OTHER(rowIndex)"></button>
                            <button kendoButton class="add-btn" icon="delete" look="flat"
                                (click)="deleteRow_OTHER(rowIndex)"></button> -->
                            </ng-template>

                        </kendo-grid-column>
                    </kendo-grid>
                    <!-- <div class="row">
                        <div class="col-md-1">
                            <btn [label]="'Back'" (click)="goToBackTab()" [class]="'btn-next btn-11'" [type]="'button'"
                                title="Back Tab"></btn>
                        </div>
                        <div class="col-md-1">
                            <btn [label]="'Add'" (click)="addnewrow_OTHER()" [class]="'btn-1 btn-11'" [type]="'button'">
                            </btn>
                        </div>
                        <div class="col-md-1">
                            <btn [label]="'Save'" (click)="save_OtherEnclosure($event,entities_OTHER)"
                                [class]="'btn-1 btn-11'" [disabled]="OtherDisabled" [type]="'button'"></btn>
                        </div>
                        <div class="col-md-1">
                            <btn [label]="'Submit'" (click)="save_all($event)" [class]="'btn-next btn-11'"
                                [type]="'button'"></btn>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</div>
<ng-template #view let-dataItem let-rowIndex="rowIndex">
    <i class="bi bi-eye-fill" (click)="open(dataItem)"></i>
</ng-template>
<kendo-dialog title="Director Details" *ngIf="opened" (close)="close()" [height]="500" [width]="1000">
    <div class="col-md-12">
        <!-- <div class="form-body"> -->
        <!-- <div class="row"> -->
        <div class="row">
            <div class="col-md-4 br-table-data">
                <label for="DirectorName" class="label label-1">Director Name : </label> {{details.DirectorName }}
            </div>
            <div class="col-md-4 br-table-data">
                <label for="DesignationName" class="label label-1">Designation : </label> {{details.DesignationName}}
            </div>
            <div class="col-md-4 br-table-data">
                <label for="Membership" class="label label-1">Membership: </label> {{details.Membership}}
            </div>
        </div>
        <div class="row">
            <div class="col-md-4 br-table-data">
                <label for="EmailId" class="label label-1">Email Id : </label> {{details.EmailId}}
            </div>
            <div class="col-md-4 br-table-data">
                <label for="Phone" class="label label-1">Phone Number : </label> {{details.Phone}}
            </div>


            <div class="col-md-4 br-table-data">
                <label for="DIN" class="label label-1">DIN: </label> {{details.DIN}}
            </div>
        </div>
        <div class="row">
            <div class="col-md-4 br-table-data">
                <label for="PAN" class="label label-1">PAN : </label> {{details.PAN}}
            </div>
            <div class="col-md-4 br-table-data">
                <label for="Aadhar" class="label label-1">Aadhar : </label> {{details.Aadhar}}
            </div>


            <div class="col-md-4 br-table-data">
                <label for="DOB" class="label label-1">Date Of Birth: </label> {{details.DOB|date:'dd-MM-yyyy'}}
            </div>
        </div>
        <div class="row">
            <div class="col-md-4 br-table-data">
                <label for="AppointmentDate" class="label label-1">Date of Appointment : </label>
                {{details.AppointmentDate|date:'dd-MM-yyyy'}}
            </div>
            <div class="col-md-4 br-table-data">
                <label for="ReAppointmentDate" class="label label-1">Date of Re-Appointment : </label>
                {{details.ReAppointmentDate|date:'dd-MM-yyyy'}}
            </div>
        </div><br><br>
        <div>
            <div class="col-md-7 text-bold">
                {{ EduQualificationCaption }}
            </div>
            <div>
                <grid [entities]="details.DirectorEducationalQualification"
                    [actionExclude]="['feedback','column','add','edit','delete','download','refresh']"
                    [checkboxCol]="false" [entityColumns]="QualificationColumns"></grid>
            </div>
        </div><br><br>
        <div>
            <div class="col-md-7 text-bold">
                {{ ProExperienceCaption }}
            </div>
            <div>
                <grid [entities]="details.DirectorProfessionalExperience"
                    [actionExclude]="['feedback','column','add','edit','delete','download','refresh']"
                    [checkboxCol]="false" [entityColumns]="ProExperienceColumns"></grid>
            </div>
        </div><br><br>
        <div>
            <div class="col-md-7 text-bold">
                {{ FormFiledCaption }}
            </div>
            <div>
                <grid [entities]="details.DirectorFormsFiledAndIntimations"
                    [actionExclude]="['feedback','column','add','edit','delete','download','refresh']"
                    [checkboxCol]="false" [entityColumns]="FormFiledColumns"></grid>
            </div>
        </div><br><br>
        <div>
            <div class="col-md-7 text-bold">
                {{ OtherEnclosureCaption }}
            </div>
            <div>
                <grid [entities]="details.DirectorOtherEnclosure"
                    [actionExclude]="['feedback','column','add','edit','delete','download','refresh']"
                    [checkboxCol]="false" [entityColumns]="otherColumns"></grid>
            </div>
        </div>
    </div>
</kendo-dialog>

<kendo-excelexport [data]="directors.data" [collapsible]="true" fileName="Director.xlsx" #excelexport>
    <kendo-excelexport-column field="SlNo" title="SlNo" [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="DirectorName" title="Name" [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="DesignationName" title="Designation" [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="EmailId" title="Email" [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="Phone" title="Phone" [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="Active" title="Active" [width]="200">
    </kendo-excelexport-column>
</kendo-excelexport>